import React from 'react';
import { string, bool, func } from 'prop-types';

// Import styled components
import { StyledLink, StyledAnchorLink } from '../common_styles';

const MenuLink = ({ isInternalLink, path, name, link, toggle, isMainLink }) => {
	if (isInternalLink)
		return (
			<StyledLink
				to={path}
				onClick={toggle}
				title={name}
				isMainLink={isMainLink}
			>
				{name}
			</StyledLink>
		);
	return (
		<StyledAnchorLink
			href={link}
			onClick={toggle}
			title={name}
			isMainLink={isMainLink}
		>
			{name}
		</StyledAnchorLink>
	);
};

MenuLink.defaultProps = {
	isMainLink: false
};

MenuLink.propTypes = {
	isInternalLink: bool.isRequired,
	name: string.isRequired,
	toggle: func.isRequired,
	link: string.isRequired,
	path: string,
	isMainLink: bool
};

export default MenuLink;
